import { useMemo } from 'react';
import { useLocation } from 'react-router';

const useQuery = (paramKey, paramValue) => {
  const { search } = useLocation();
  const queryParams = useMemo(() => new URLSearchParams(search), [search]);

  const isQueryParamTrue = useMemo(() => {
    const value = queryParams.get(paramKey);
    return value === paramValue;
  }, [queryParams, paramKey, paramValue]);

  return { queryParams, isQueryParamTrue };
};

export default useQuery;
